import { ActionGroupTypes, ActionStatusTypes } from "../../../enum/ActionStatusTypes";
import * as logger from "../../../logger";
import { getNodeById } from "../../../nodeSelector";
import * as nodeUtils from "../../../utils/nodeUtils";
import * as systemUtils from "../../../utils/systemUtils";
import { ACTION_PREFIX_FUNCTION } from "./abstract/functionAbstract";
import { getFunctionReferences, processFunctionReferences } from "./helpers/functionHelper";

const _action = `${ACTION_PREFIX_FUNCTION}_update_name`;
const _header = `Rename function`;

export const updateFunctionName = (root, id, name, lastPayload) => {
  const _payload = updateFunctionNameLogic(root, id, name, lastPayload);

  logger.logAction(_action, _payload, ACTION_PREFIX_FUNCTION);

  return { root, info: _payload };
};

//--------------------------------------------------------------------------------

export const updateFunctionNameLogic = (root, id, name, lastPayload) => {
  const { data: _node, index: _index } = getNodeById(root, id);

  if (!_node) {
    throw new Error("Function to update not found");
  }

  if (nodeUtils.getName(_node) === name) {
    return generatePayloadIndifferent();
  }

  const _nodeBackup = systemUtils.createDeepCopy(_node);
  const _references = getFunctionReferences(root, _node);

  const _idTrack = nodeUtils.setName(_node, name, true);

  handleReferences(_references, _idTrack);

  return generatePayload(_nodeBackup, _index, _references.description, nodeUtils.getName(_node), lastPayload);
};

const handleReferences = (references, idTrack) => {
  const funTarget = (e) => {
    nodeUtils.removeIdReference(e.dst, idTrack.get(nodeUtils.getID(e.src)));
    nodeUtils.addIdReference(e.dst, nodeUtils.getID(e.src));
  };

  processFunctionReferences(references, funTarget);
};

//--------------------------------------------------------------------------------

const generatePayload = (node, index, uuidReferences, nameAfter, lastPayload) => {
  if (!nodeUtils.getName(node)) {
    return generatePayloadCreate(node, index, uuidReferences, nameAfter, lastPayload);
  }

  return generatePayloadUpdate(node, index, uuidReferences, nameAfter)
}

const generatePayloadCreate = (node, index, uuidReferences, nameAfter, previousAction) => {
  const _payload = {
    group: ActionGroupTypes.ADD,
    status: ActionStatusTypes.SUCCESS,
    action: _action,
    time: systemUtils.getTimestamp(),
    header: _header,
    description: `${previousAction.description} Name: '${nameAfter}'.`,
    node: node,
    uuid: nodeUtils.getUUID(node),
    index: index,
    nameBefore: nodeUtils.getName(node),
    nameAfter: nameAfter,
  }

  return _payload;
}

const generatePayloadUpdate = (node, index, uuidReferences, nameAfter) => {
  const _payload = {
    group: ActionGroupTypes.UPDATE,
    status: ActionStatusTypes.SUCCESS,
    action: _action,
    time: systemUtils.getTimestamp(),
    header: _header,
    description: generatePayloadDescription(node, nameAfter),
    node: node,
    uuid: nodeUtils.getUUID(node),
    index: index,
    nameBefore: nodeUtils.getName(node),
    nameAfter: nameAfter,
  };

  return { ..._payload, ...uuidReferences };
};

const generatePayloadIndifferent = () => {
  const _payload = {
    status: ActionStatusTypes.INDIFFERENT,
    action: _action,
    time: systemUtils.getTimestamp()
  }

  return _payload;
}

const generatePayloadDescription = (node, nameAfter) => {

    return `Rename function '${nodeUtils.getName(node)}' to '${nameAfter}'.`;
}
